// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__3F89P","ranges":"BmiRanges_ranges__27Oyn"};